import { MainAppResource } from './base';

export default function Guard1000FaultLastWaveform({ externalGuardId }) {
  return MainAppResource(`api/v3/guards1000/${externalGuardId}/fault_event_waveforms/last{/code}`);
}
